import React from 'react';

interface IProps {
  firstColumnClassname?: string;
  secondColumnClassname?: string;
  thirdColumnClassname?: string;
  firstColumnChildren?: React.ReactNode[] | null;
  secondColumnChildren?: React.ReactNode[];
  thirdColumnChildren?: React.ReactNode[];
}

const ThreeColumnsContainer = ({
  firstColumnClassname, secondColumnClassname, thirdColumnClassname, firstColumnChildren, secondColumnChildren, thirdColumnChildren,
}:IProps) => {
  const fillingWithKeys = (children?: React.ReactNode[]) => (children ? children.map((child, index) => <div key={`child${index.toString()}`}>{child}</div>) : undefined);
  return (
    <>
      <div className={firstColumnClassname}>{firstColumnChildren && fillingWithKeys(firstColumnChildren)}</div>
      <div className={secondColumnClassname}>{fillingWithKeys(secondColumnChildren)}</div>
      {thirdColumnChildren && thirdColumnClassname && <div className={thirdColumnClassname}>{fillingWithKeys(thirdColumnChildren)}</div>}
    </>
  );
};

export default ThreeColumnsContainer;
